module.exports = __webpack_public_path__ + "img/南宁百盛.581c7350.png";